module.exports = __webpack_public_path__ + "static/media/october.b8867973.png";